import { useSelector } from 'react-redux';
import { MapContainer } from '@components/Boss/MapContainer';
import StoreDetails from '@components/Boss/StoreDetails';

const StoreInfo = props => {
  const mapLink = useSelector((state) => state.cart.mapLink);

  return (
    <div className="container-fluid-boss">
      <div className="row map-container">
        <div className="map-container-inner"> {mapLink && <MapContainer link={mapLink} />}</div>
      </div>
      <div className="row">
        <div className="store-details-container">
          <StoreDetails config={props.config}></StoreDetails>
        </div>
      </div>
    </div>
  );
};

export default StoreInfo;
